 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin","route-boxs~route-gift":"route-boxs~route-gift","route-boxs":"route-boxs","route-gift":"route-gift","route-gashapon":"route-gashapon","route-huay":"route-huay","route-roulet":"route-roulet","route-spin":"route-spin","route-cashback":"route-cashback","route-continue":"route-continue","route-history":"route-history","route-home~route-qilin~route-worldcup~route-worldcup-ranking":"route-home~route-qilin~route-worldcup~route-worldcup-ranking","route-home~route-qilin":"route-home~route-qilin","route-home":"route-home","route-qilin":"route-qilin","route-worldcup":"route-worldcup","route-worldcup-ranking":"route-worldcup-ranking","route-login":"route-login","route-partner":"route-partner","route-play":"route-play","route-play-game":"route-play-game","route-promotion":"route-promotion","route-register":"route-register","route-register-pass":"route-register-pass","route-rewards":"route-rewards"}[chunkId]||chunkId) + "." + {"about":"8d4c9848","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"d9375cc1","route-boxs~route-gift":"7f1f99dd","route-boxs":"11c1c430","route-gift":"a4cc106c","route-gashapon":"9b58d803","route-huay":"2ebd49d4","route-roulet":"9519c040","route-spin":"4da6c06a","route-cashback":"606377ad","route-continue":"927d0ec5","route-history":"ff13ff6f","route-home~route-qilin~route-worldcup~route-worldcup-ranking":"baa88069","route-home~route-qilin":"028cc0bc","route-home":"b5bf107d","route-qilin":"e489ee99","route-worldcup":"13d6a876","route-worldcup-ranking":"4491e3af","route-login":"6bd0c279","route-partner":"11b87bb8","route-play":"5a66e7ad","route-play-game":"ac6f07d3","route-promotion":"34a5171b","route-register":"53933446","route-register-pass":"51157eb9","route-rewards":"c40546bb","chunk-6c4f0542":"f84e531c","chunk-73fb54a4":"bfaf4d08","chunk-36f67272":"e34c922f","chunk-00ebb084":"2d7788b4","chunk-a8bf002e":"0af4af44","chunk-0b1f92e1":"9f326acd","chunk-073e7273":"efd3c8da","chunk-195940cf":"2b3175f7","chunk-b846cd0e":"97f8e8a2","chunk-4a3a9c76":"ba54b0cc","chunk-0dfbe6dc":"4a1b4e21","chunk-8374f3a8":"332a4bc2","chunk-003bec20":"8da12980","chunk-1ed708ec":"4e4ce0aa"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":1,"route-boxs~route-gift":1,"route-boxs":1,"route-gift":1,"route-gashapon":1,"route-huay":1,"route-roulet":1,"route-spin":1,"route-cashback":1,"route-continue":1,"route-history":1,"route-home":1,"route-qilin":1,"route-worldcup":1,"route-worldcup-ranking":1,"route-login":1,"route-partner":1,"route-register":1,"route-register-pass":1,"route-rewards":1,"chunk-73fb54a4":1,"chunk-195940cf":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin","route-boxs~route-gift":"route-boxs~route-gift","route-boxs":"route-boxs","route-gift":"route-gift","route-gashapon":"route-gashapon","route-huay":"route-huay","route-roulet":"route-roulet","route-spin":"route-spin","route-cashback":"route-cashback","route-continue":"route-continue","route-history":"route-history","route-home~route-qilin~route-worldcup~route-worldcup-ranking":"route-home~route-qilin~route-worldcup~route-worldcup-ranking","route-home~route-qilin":"route-home~route-qilin","route-home":"route-home","route-qilin":"route-qilin","route-worldcup":"route-worldcup","route-worldcup-ranking":"route-worldcup-ranking","route-login":"route-login","route-partner":"route-partner","route-play":"route-play","route-play-game":"route-play-game","route-promotion":"route-promotion","route-register":"route-register","route-register-pass":"route-register-pass","route-rewards":"route-rewards"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","route-boxs~route-gashapon~route-gift~route-huay~route-roulet~route-spin":"fc7c866d","route-boxs~route-gift":"f1839825","route-boxs":"703ad50d","route-gift":"3b0b0b30","route-gashapon":"9e4042c5","route-huay":"a69b691b","route-roulet":"dec935fa","route-spin":"5efdfbd6","route-cashback":"148e2e61","route-continue":"e6748640","route-history":"4f2cc087","route-home~route-qilin~route-worldcup~route-worldcup-ranking":"31d6cfe0","route-home~route-qilin":"31d6cfe0","route-home":"740ea281","route-qilin":"9bbc5a88","route-worldcup":"02a81499","route-worldcup-ranking":"5f37158b","route-login":"bd06aa9e","route-partner":"7ed3f914","route-play":"31d6cfe0","route-play-game":"31d6cfe0","route-promotion":"31d6cfe0","route-register":"b897f338","route-register-pass":"1f850aca","route-rewards":"776d2b46","chunk-6c4f0542":"31d6cfe0","chunk-73fb54a4":"12b9b36e","chunk-36f67272":"31d6cfe0","chunk-00ebb084":"31d6cfe0","chunk-a8bf002e":"31d6cfe0","chunk-0b1f92e1":"31d6cfe0","chunk-073e7273":"31d6cfe0","chunk-195940cf":"fdc6c028","chunk-b846cd0e":"31d6cfe0","chunk-4a3a9c76":"31d6cfe0","chunk-0dfbe6dc":"31d6cfe0","chunk-8374f3a8":"31d6cfe0","chunk-003bec20":"31d6cfe0","chunk-1ed708ec":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
